import { atom, AtomEffect } from "recoil";

const sessionStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue, _, isReset) => {
      isReset
        ? sessionStorage.removeItem(key)
        : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };

export const emailState = atom({
  key: "email",
  default: "",
  effects: [sessionStorageEffect("email")],
});

export const marketingPermissionState = atom({
  key: "marketingPermission",
  default: false,
  effects: [sessionStorageEffect("marketingPermission")],
});

export const venueIdState = atom({
  key: "venueId",
  default: 1,
  effects: [sessionStorageEffect("venueId")],
});

export const parentFirstNameState = atom({
  key: "parentFirstName",
  default: "",
  effects: [sessionStorageEffect("parentFirstName")],
});

export const parentLastNameState = atom({
  key: "parentLastName",
  default: "",
  effects: [sessionStorageEffect("parentLastName")],
});

export const parentSignatureState = atom({
  key: "parentSignature",
  default: "",
});

export const parentSignatureDateState = atom({
  key: "parentSignatureDate",
  default: "",
});
